import { render, staticRenderFns } from "./MarketList.vue?vue&type=template&id=0ec7f333&scoped=true&"
import script from "./MarketList.vue?vue&type=script&lang=js&"
export * from "./MarketList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec7f333",
  null
  
)

export default component.exports